import axiosInstance from './axiosConfig';

const expenseService = {
  getAll: async (page = 1, limit = 10) => {
    console.log('API CALL → page:', page, 'limit:', limit);

    const response = await axiosInstance.get(
      `/expenses?page=${page}&limit=${limit}`
    );

    // Extract the actual data array
    const expenses = response.data.data ?? response.data;
    
    // Debug: Check if IDs are present
    console.log('Expenses from API:', expenses);
    if (expenses.length > 0) {
      console.log('First expense keys:', Object.keys(expenses[0]));
    }
    
    return expenses;
  },
  
  getById: async (id) => {
    const response = await axiosInstance.get(`/expenses/${id}`);
    return response.data.data ?? response.data;
  },
  
  create: async (payload) => {
    const response = await axiosInstance.post('/expenses/create', payload);
    return response.data;
  },

  getActiveInventories: async () => {
    const response = await axiosInstance.get('/inventories/active');
    return response.data.data ?? response.data;
  },
  
  update: async (id, data) => {
    console.log('Updating expense with ID:', id);
    console.log('Update data:', data);
    
    const response = await axiosInstance.put(`/expenses/edit/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/expenses/delete/${id}`);
    return response.data;
  },
  
  filter: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.type) params.append('type', filters.type);
    
    const response = await axiosInstance.get(
      params.toString()
        ? `/expenses?${params.toString()}`
        : '/expenses'
    );
    return response.data.data ?? response.data;
  },
};

export default expenseService;
